import { ApiServiceV1 } from '@services/api.service';

export default {
  async getAppSettings() {
    const { data } = await ApiServiceV1.get('account/settings');
    return data;
  },
};
